import React from "react";
import { translate } from "Translate";
import injectSheet from "react-jss";
import styles from "./styles";
import Grid from "@material-ui/core/Grid";

function isActiveBanner(banner) {
    return (
        banner !== null &&
        banner !== undefined &&
        Object.keys(banner).length > 0
    );
}

const BannerNotificationAlerts = props => {  
    const { currentMarket, rosettaAlterations, bannerFlagLD, classes, flagNameLD } = props;

    if (!isActiveBanner(bannerFlagLD)) {
        return null;
    }

    if (!bannerFlagLD.markets.includes(currentMarket)) {
        return null;
    }

    const displayMessage = rosettaAlterations(translate(bannerFlagLD.rosettaTag), bannerFlagLD);

    if (displayMessage === "") {
        console.warn("Notification Banner is Active but not formated properly, No message to display for, ", flagNameLD);
        return null;
    }

    return (
        <Grid item xs={12}>
            <div css={styles}>
                <div className={classes.banner}>
                    <div
                        className={classes.message}
                        dangerouslySetInnerHTML={{
                            __html: displayMessage
                        }}
                    />
                </div>
            </div>
        </Grid>
    );
    
}

export default injectSheet(styles)(BannerNotificationAlerts);


// WEBPACK FOOTER //
// ./src/components/Common/BannerNotificationAlerts/index.js